import { render } from "./menu1-2.vue?vue&type=template&id=41269ae6"
import script from "./menu1-2.vue?vue&type=script&lang=ts"
export * from "./menu1-2.vue?vue&type=script&lang=ts"
script.render = render

export default script